import Contact from "@/components/sections/Contact";
import FAQ from "@/components/sections/FAQ";
import Breadcrumb from "@/components/Breadcrumb";

export default function ContactPage() {
  return (
    <>
      <section className="pt-32 pb-16 lg:pt-40 lg:pb-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Contact</p>
          <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-slate-900 leading-[1.05] tracking-tight max-w-4xl mx-auto">
            Talk to our HR experts
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-slate-600 leading-relaxed">
            Whether you need recruitment, contract staffing, payroll outsourcing or HR consultancy — we're ready to help.
          </p>
        </div>
      </section>
      <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Contact" }]} />
      <Contact />
      <FAQ />
    </>
  );
}
